import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import { MegaMenuNavItem } from './types';

import getRegistryNavData from './registryNavData';

const {
  PRIMARY: { REGISTRY },
} = NAV_DATA;

const getRegistry = (userContext: UserContext | undefined): MegaMenuNavItem => {
  return getRegistryNavData({
    id: REGISTRY,
    onboardPath: '/onboard/new',
    registryPath: '/wedding-registry',
    userContext,
  });
};

export default getRegistry;
